import { ShippingPriceBandDTO } from '@invenco/shipping-interface';

const convertUndefined = (value: number | null | undefined) =>
  value === undefined || value === null ? Number.MAX_VALUE : value;

export function sortBands(priceBands: ShippingPriceBandDTO[]) {
  return [...priceBands].sort((a, b) => convertUndefined(a.maxCost) - convertUndefined(b.maxCost));
}
